// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"624":"85cf5b77","974":"d4a7b0fb"}[chunkId] + ".chunk.css";
};